import {DeserializableModel} from '../deserializable.model';

export interface Error {
	message: string;
	code: number;
}

export class ErrorModel implements DeserializableModel, Error {
	message: string;
	code: number;

	constructor(message, code = -1) {
		this.message = message;
		this.code = code;
	}

	deserialize(input: any): this {
		Object.assign(this, input);
		return this;
	}

	serialize(): string {
		return JSON.stringify(this);
	}
}
